import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
//clients
import Clients_List from '@/components/clients/ListClients'
//users
import Users_List from '@/components/users/ListUsers'
//apps
import Apps_List from '@/components/applications/ListApps'
//keys
import Keys_List from '@/components/keys/ListKeys'

import store from '@/store/store'

Vue.use(Router)

export let router = new Router({
    routes: [{
            path: '/',
            name: 'empty-path',
            component: Keys_List,
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                auth: false
            }
        },
        //clients
        {
            path: '/clients',
            name: 'clients-list',
            component: Clients_List,
            meta: {
                auth: true
            }
        },
        //users
        {
            path: '/users',
            name: 'users-list',
            component: Users_List,
            meta: {
                auth: true
            }
        },
        //apps
        {
            path: '/apps',
            name: 'apps-list',
            component: Apps_List,
            meta: {
                auth: true
            }
        },
        //keys
        {
            path: '/keys',
            name: 'keys-list',
            component: Keys_List,
            meta: {
                auth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !store.state.isUserLoggedIn) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    if (to.meta.auth && store.state.logTime == null) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      if (to.meta.auth && (Date.now() - store.state.logTime >= 43200000)) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        next();
      }
    }
  }
})